export default __webpack_public_path__ + "static/media/falcon-join-active.1d7f47ec.svg";